export default "__VITE_ASSET__W77lCeO4__"